import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import depart, { departSaga } from './depart';
import departs, { departsSaga } from './departs';

const departModule = combineReducers({
    depart,
    departs
});

export function* departModuleSaga() {
  yield all([
    departSaga(),
    departsSaga(),
  ]);
}

export default departModule;
